import { internalRoutes } from './routes.const';

// Export routes
export const routes = internalRoutes;

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
